(function () {
  function initHeroSlideshow(root) {
    var slides = root.querySelectorAll('.diip-hero2__slide');
    if (slides.length < 2) return;

    var speed = parseFloat(root.getAttribute('data-autoplay')) || 5;
    var index = 0;

    /*
      DIIP UPDATE: หา CTA ปุ่มที่ 1 (data-hero-cta-primary) และ Heading/
      Description ที่อยู่ใน media-box เดียวกัน เพื่อสลับข้อความให้ตรงกับ
      สไลด์ที่กำลัง Active อยู่ — ค่า data-button-link/text,
      data-heading-line1/2, data-description ถูกเตรียมไว้แล้วที่ตัวสไลด์
      แต่ละอันจากไฟล์ .liquid (fallback ไปใช้ค่า default ของ Section ให้
      เรียบร้อยตั้งแต่ฝั่ง Liquid แล้ว ไม่ต้องเช็ค blank ซ้ำที่นี่)
    */
    var mediaBox = root.closest('.diip-hero2__media-box');
    var ctaBtn = mediaBox ? mediaBox.querySelector('[data-hero-cta-primary]') : null;
    var ctaText = ctaBtn ? ctaBtn.querySelector('[data-hero-cta-primary-text]') : null;
    var headingLine1El = mediaBox ? mediaBox.querySelector('[data-hero-heading-line1]') : null;
    var headingLine2El = mediaBox ? mediaBox.querySelector('[data-hero-heading-line2]') : null;
    var descriptionEl = mediaBox ? mediaBox.querySelector('[data-hero-description]') : null;

    function applyCta(slide) {
      if (!ctaBtn) return;
      var link = slide.getAttribute('data-button-link');
      var text = slide.getAttribute('data-button-text');
      if (link) ctaBtn.setAttribute('href', link);
      if (ctaText && text) ctaText.textContent = text;
    }

    function applyText(slide) {
      var line1 = slide.getAttribute('data-heading-line1');
      var line2 = slide.getAttribute('data-heading-line2');
      var desc = slide.getAttribute('data-description');
      if (headingLine1El && line1) headingLine1El.textContent = line1;
      if (headingLine2El && line2) headingLine2El.textContent = line2;
      /* description เป็น richtext (มี HTML tag) ใช้ innerHTML แทน textContent */
      if (descriptionEl && desc) descriptionEl.innerHTML = desc;
    }

    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
      applyCta(slides[index]);
      applyText(slides[index]);
    }, speed * 1000);
  }

  document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
})();
